import { render, staticRenderFns } from "./ObjektiCard2Tab-9-Kategorizacija.vue?vue&type=template&id=d9d3cf5c&scoped=true&"
import script from "./ObjektiCard2Tab-9-Kategorizacija.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-9-Kategorizacija.vue?vue&type=script&lang=ts&"
import style0 from "./ObjektiCard2Tab-9-Kategorizacija.vue?vue&type=style&index=0&id=d9d3cf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d3cf5c",
  null
  
)

export default component.exports